const getPropertyCodes = (json) => {
    let propertyCodes = [];
    let propertyDescriptions = {};
    for (let propertyIndex in json.property) {
        let property = json.property[propertyIndex];
        let propertyCode = property.code;
        if (propertyCode && !propertyCodes.includes(propertyCode)) {
            propertyCodes.push(propertyCode);
            propertyDescriptions[propertyCode] = property.description;
        }
    }
    return { propertyCodes: propertyCodes, propertyDescriptions: propertyDescriptions };
};

export default getPropertyCodes;